import { render, staticRenderFns } from "./WhatsappCampaignSetup.vue?vue&type=template&id=44fa58de"
import script from "./WhatsappCampaignSetup.vue?vue&type=script&lang=js"
export * from "./WhatsappCampaignSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports